module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-114x114-precomposed-6e028713.png";